/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
import { StringBuilder } from "igniteui-react-core";
/**
 * @hidden
 */
var PopupVisualModelExport = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(PopupVisualModelExport, _super);
    function PopupVisualModelExport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.e = 0;
        _this.d = false;
        _this.c = null;
        _this.b = null;
        _this.a = null;
        return _this;
    }
    PopupVisualModelExport.prototype.f = function () {
        var a = new StringBuilder(0);
        a.l("{");
        a.l("actualElevation : " + this.e + ", ");
        a.l("isShown : " + this.d + ", ");
        a.l("actualUmbraShadowColor : " + this.c.serialize() + ", ");
        a.l("actualPenumbraShadowColor : " + this.b.serialize() + ", ");
        a.l("actualAmbientShadowColor : " + this.a.serialize() + ", ");
        a.l("}");
        return a.toString();
    };
    PopupVisualModelExport.$t = markType(PopupVisualModelExport, 'PopupVisualModelExport');
    return PopupVisualModelExport;
}(Base));
export { PopupVisualModelExport };
//# sourceMappingURL=PopupVisualModelExport.js.map
